export const NFTTypeArray: string[] = [
    /* 0 */ "Ticket",
    /* 1 */ "Blindbox",
    /* 2 */ "Gallery",
]